import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const FlowCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    /* width: 261px; */
    /* height: 271px; */
    height: 180px;
    /* flex-wrap: wrap; */
    /* border: 1px solid var(--color-gray-200); */
    background-color: var(--color-white);
    box-shadow: 0px 1px 3px 0px #1018281a;
    border-radius: 16px;
    padding: 20px;
    /* margin-right: 20px; */
    /* margin-bottom: 20px; */
    justify-content: space-between;
    transition: box-shadow 0.2s ease;
    &:hover {
        box-shadow: 0px 4px 12px 0px #1018281a;
    }
    cursor: pointer;
`

export const Header = styled.div`
    display: flex;
    width: 100%;
`

export const HeaderIcon = styled.div`
    margin-right: 8px;
`

export const HeaderText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
`

export const HeaderTextType = styled.div`
    color: var(--color-gray-500);
    font-size: 12px;
    line-height: 12px;
`

export const FlowCardContent = styled.div`
    width: 100%;
`

export const FlowCardHeader = styled.div`
    position: relative;
    width: 100%;
`

export const FlowCardIconsWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    /* width: 212px; */
    flex: 1;
`

export const FlowCardTriggerIcon = styled(IconFont)`
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: var(--color-gray-400);
    flex-shrink: 0;
`

export const FlowCardExtraLinearBackground = styled.div`
    width: 14px;
    height: 28px;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(to right, transparent, #fff);
`

export const FlowCardActionWrapper = styled.div`
    background-color: var(--color-white);
    position: absolute;
    /* z-index: 10; */
    right: 0;
    top: 0;
    width: 32px;
    height: 32px;
    opacity: 0;
    transition: all 0.2s ease;
    display: flex;
    flex-flow: row nowrap;

    ${FlowCardWrapper}:hover & {
        opacity: 1;
    }
`

export const FlowCardAction = styled(IconFont)`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    text-align: center;
    border: 1px solid var(--color-gray-200);
    cursor: pointer;
    line-height: 32px;

    &:hover {
        background-color: var(--color-gray-100);
    }
`

export const FlowCardDescription = styled.p`
    font-size: var(--font-size-sm);
    color: var(--color-gray-500);
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 12px;
`

export const FlowCardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

export const FlowCardFooterLeft = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const FlowCardStatusWrapper = styled.div`
    margin-left: 8px;
    display: flex;
    align-items: center;
`

export const FlowCardStatus = styled(IconFont)``
